import * as React from "react";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { INPUT_LABEL_PROPS } from "../../pages/shared/constants";

interface DailyBudgetDatePickerProps {
  value: string;
  onChange: (date: string) => void;
}

export default function DailyBudgetDatePicker({ value, onChange }: DailyBudgetDatePickerProps) {
  const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(dayjs(value));

  React.useEffect(() => {
    setSelectedDate(dayjs(value));
  }, [value]);

  const handleDateChange = (newDate: Dayjs | null) => {
    setSelectedDate(newDate);
    if (newDate) {
      onChange(newDate.format("YYYY-MM-DD"));
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label="Selecciona un día"
        value={selectedDate}
        onChange={handleDateChange}
        slotProps={{ textField: { InputLabelProps: INPUT_LABEL_PROPS, fullWidth: true } }}
      />
    </LocalizationProvider>
  );
}
